<div class="row">

    <div v-if="form.byType === 0" class="col-12 col-md-3 mt-4">
        <FormInput
            field-name="surname"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div class="col-12 col-md-3 mt-4">
        <FormInput
            field-name="name"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div v-if="form.byType === 0" class="col-12 col-md-3 mt-4">
        <FormInput
            field-name="patronymic"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div class="col-12 col-md-3 mt-4">
        <FormInput
            field-name="phone"
            type="number"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div class="col-12 col-md-6 mt-4">
        <Selection
            endpoint="town"
            :value="form.townLabel"
            :form-errors="v.form"
            :items="searchTownItems"
            :disabled="form.byType === 1"
            placeholder="Укажите населённый пункт"
            title="Населённый пункт"
            @select="setTown($event)"
        >
            <template v-slot:default="props">
                {{ props.item.town.type.short_name }} {{ props.item.town.name + (props.item.town.district.region.name ? ',' : '') }}
                <span class="region-label">
                    {{ props.item.town.district.region.name ? props.item.town.district.region.name + ' обл.,' : '' }}
                    {{ props.item.town.district.name ? props.item.town.district.name + ' р-н' : '' }}
                </span>
            </template>
        </Selection>

        <div v-if="estimatedDeliveryDate" class="small py-2">
            Примерная дата доставки:
            <span style="color: rgb(229, 57, 53)">
                {{ estimatedDeliveryDate }}
            </span>
        </div>
    </div>

    <div class="col-12 col-md-6 mt-4">
        <Selection
            endpoint="street"
            :value="form.streetLabel"
            :form-errors="v.form"
            :items="searchStreetItems"
            :disabled="!fieldDeps.street.parent_id"
            placeholder="Укажите улицу"
            title="Улица"
            @select="setStreet($event)"
        >
            <template v-slot:default="props">
                {{ props.item.street.type.short_name }} {{ props.item.street.name }}
            </template>
        </Selection>
    </div>

    <div class="col-6 col-md-3 mt-4">
        <FormInput
            field-name="house"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div class="col-6 col-md-3 mt-4">
        <FormInput
            field-name="pav"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div v-if="form.byType === 0" class="col-6 col-md-3 mt-4">
        <FormInput
            field-name="apart"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div v-if="form.byType === 0" class="col-6 col-md-3 mt-4">
        <FormInput
            field-name="index"
            type="number"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div v-if="form.byType === 1" class="col-6 col-md-3 mt-4">
        <FormInput
            field-name="door_num"
            type="number"
            :form-errors="v.form"
            @run-validate="validateField($event)"
            @input="updateForm($event.e)"
        />
    </div>

    <div v-if="form.byType === 1" class="col-12 col-md-3 mt-4">
        <div class="b-field-title">
            Выберите дату доставки:
        </div>

        <div class="d-flex flex-column">
            <label>
                <input
                    type="radio"
                    name="date"
                    value="2 июня"
                    @change="updateForm({date: $event.target.value.trim()})"
                >
                2 июня
            </label>
        </div>
    </div>

    <div v-if="form.byType === 1" class="col-12 col-md-3 mt-4">
        <div class="b-field-title">
            Выберите время доставки:
        </div>

        <div class="d-flex flex-column">
            <label>
                <input
                    type="radio"
                    name="time"
                    value="с 11:00 до 14:00"
                    @change="updateForm({time: $event.target.value.trim()})"
                >
                с 11:00 до 14:00
            </label>

            <label>
                <input
                    type="radio"
                    name="time"
                    value="с 14:00 до 20:00"
                    @change="updateForm({time: $event.target.value.trim()})"
                >
                с 14:00 до 20:00
            </label>
        </div>
    </div>

</div>
